import React, { useEffect, useState } from 'react';
import './SuggestionAndNotification.css';

const SuggestionAndNotification = ({ step, notification, onSuggestionClick }) => {
    const [suggestions, setSuggestions] = useState([]);

    useEffect(() => {
        const fetchSuggestions = async () => {
            try {
                const response = await fetch(
                    `${process.env.REACT_APP_API_SERVER_URL}/chat/getsuggestbystep`,
                    {
                        method: 'GET',
                        headers: { 'Content-Type': 'application/json' },
                    }
                );
                const data = await response.json();

                if (Array.isArray(data)) {
                    // Lọc các gợi ý theo step hiện tại
                    const filtered = data
                        .filter(item => item.step === step)
                        .map(item => item.message);
                    setSuggestions(filtered);
                } else {
                    setSuggestions([]);
                }
            } catch (error) {
                console.error('Error fetching suggestions:', error);
                setSuggestions([]);
            }
        };

        if (step) {
            fetchSuggestions();
        }
    }, [step]);

    return (
        <div className="suggestion-notification-container">
            {/* Thông báo lỗi */}
            {notification && (
                <div className="notification-error">
                    <div className="notification-content">
                        {notification}
                    </div>
                </div>
            )}

            {/* Gợi ý */}
            {suggestions.length > 0 && (
                <div className="suggestions-container">
                    <div className="suggestions-list">
                        {suggestions.map((suggestion, index) => (
                            <button
                                key={index}
                                className="suggestion-btn"
                                onClick={() => onSuggestionClick(suggestion)}
                                style={{
                                    overflow: "visible",
                                    width: "auto",
                                    maxWidth: "none",
                                }}
                            >
                                {suggestion}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SuggestionAndNotification;
